import { getTimestampMillis } from '../format-converter/utils';

export const ROOT_FOLDER_ID = '';

export const formatBytes = (value) => {
  const bytes = Number(value || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) return '-';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const idx = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  const size = bytes / 1024 ** idx;
  return `${size >= 100 || idx === 0 ? size.toFixed(0) : size.toFixed(1)} ${units[idx]}`;
};

export const compareText = (left, right) =>
  String(left || '').localeCompare(String(right || ''), undefined, { sensitivity: 'base' });

export const sortStorageItems = (items, sortBy) => {
  return [...items].sort((left, right) => {
    const folderRank = (left.type === 'folder' ? 0 : 1) - (right.type === 'folder' ? 0 : 1);
    if (folderRank !== 0) return folderRank;

    if (sortBy === 'name-asc') return compareText(left.name, right.name);
    if (sortBy === 'name-desc') return compareText(right.name, left.name);
    if (sortBy === 'size-desc') return Number(right.size || 0) - Number(left.size || 0);
    if (sortBy === 'size-asc') return Number(left.size || 0) - Number(right.size || 0);
    if (sortBy === 'updated-asc') return Number(getTimestampMillis(left.updatedAt) || 0) - Number(getTimestampMillis(right.updatedAt) || 0);
    return Number(getTimestampMillis(right.updatedAt) || 0) - Number(getTimestampMillis(left.updatedAt) || 0);
  });
};
